import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function usePublicRoutesEnabled() {
  const { data, isLoading } = useQuery({
    queryKey: ['platform-setting', 'public_routes_enabled'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('platform_settings')
        .select('value')
        .eq('key', 'public_routes_enabled')
        .maybeSingle();
      if (error) return true;
      const raw = data?.value;
      if (raw === false || raw === 'false') return false;
      return true;
    },
    staleTime: 60_000,
  });
  return { enabled: data ?? true, isLoading };
}
